import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Typography
} from '@mui/material'
import React from 'react'
import { get, useFormContext } from 'react-hook-form'
import { verticals } from '../../utils/verticals'
import { ControlledCheckbox } from '../ControlledCheckbox'
import { ControlledHiddenField } from '../ControlledHiddenField'

export const VerticalCheckboxes = ({ initialValues = {}, min = 3 }) => {
  const { watch, formState, setValue } = useFormContext()
  const verticalsValue = watch('verticals', initialValues)
  const verticalArray = Object.keys(verticalsValue).map(
    key => verticalsValue[key]
  )
  const hasMin = min > 0
  const disabled = hasMin ? verticalArray.filter(v => v).length >= min : false

  const error = get(formState.errors, 'verticals')

  const verticalList = verticals.sort((a, b) => a.localeCompare(b))
  const checked = verticals.length === verticalArray.filter(v => v).length

  const handleSelectAll = () => {
    if (!checked) {
      verticals.forEach(v => setValue(`verticals.${v}`, true))
    } else {
      verticals.forEach(v => setValue(`verticals.${v}`, false))
    }
  }

  return (
    <>
      <ControlledHiddenField name='verticals' />
      <FormControl component='fieldset' variant='standard'>
        <Typography variant='body1' style={{ paddingBottom: 8 }}>
          {`Content Verticals ${hasMin ? `(Pick ${min})` : ''}`}
        </Typography>
        <FormGroup>
          <Grid container spacing={0}>
            <Grid item xs={12} md={6} container spacing={0}>
              {!hasMin && (
                <FormControlLabel
                  onChange={handleSelectAll}
                  control={<Checkbox checked={checked} />}
                  label='All'
                />
              )}
              {verticalList
                .slice(0, Math.ceil(verticalList.length / 2))
                .map(vertical => (
                  <Grid item xs={12} key={vertical}>
                    <ControlledCheckbox
                      disabled={disabled && !verticalsValue[vertical]}
                      name={`verticals.${vertical}`}
                      label={vertical}
                      // checked={verticalsValue[vertical] ?? false}
                    />
                  </Grid>
                ))}
            </Grid>
            <Grid item xs={12} md={6} container spacing={0}>
              {verticalList
                .slice(Math.ceil(verticalList.length / 2))
                .map(vertical => (
                  <Grid item xs={12} key={vertical}>
                    <ControlledCheckbox
                      disabled={disabled && !verticalsValue[vertical]}
                      name={`verticals.${vertical}`}
                      label={vertical}
                      //checked={verticalsValue[vertical] ?? false}
                    />
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </FormGroup>
        {error?.message !== undefined && (
          <FormHelperText
            id={`error-helper-text-verticals`}
            error
            style={{ textAlign: 'left', paddingRight: 8 }}
          >
            {error?.message}
          </FormHelperText>
        )}
      </FormControl>
    </>
  )
}
